import { motion } from "framer-motion";
import WhaleLogo from "./WhaleLogo";
import { BUY_URL, TELEGRAM_URL, X_URL } from "../lib/constants";

const ITEMS = [
  "BIG HEART. BIGGER WAVES.",
  "JOIN THE POD",
  "MAKING WAVES ON SOLANA",
  "COMMUNITY-DRIVEN",
  "MEME-FIRST",
  "NO PROMISES. JUST WAVES.",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap px-6 font-display text-lg font-semibold tracking-wide sm:text-xl">
          {item}
        </span>
        <WhaleLogo className="h-7 w-7 shrink-0" flip={i % 2 === 0} />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section
      data-testid="marquee-band"
      className="relative z-10 -my-3 -rotate-1 border-y-4 border-ocean-navy bg-ocean-navy py-4 shadow-[0_6px_0_rgba(15,23,42,0.15)]"
    >
      <div className="flex overflow-hidden">
        <div
          className="flex w-max text-ocean-yellow"
          style={{ animation: "marquee-x 42s linear infinite" }}
        >
          <Row />
          <Row />
        </div>
      </div>
    </section>
  );
}
